import FolderOpenOutlined from '@mui/icons-material/FolderOpenOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { Box, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { WarningCell } from 'v2/components/Warning/Warning';

interface Props {
  devicesCount: number;
  groupsCount: number;
}

const DevicesAndGroupsCell: React.FC<Props> = ({ devicesCount, groupsCount }) => {
  const { translation } = useTranslation();

  if (devicesCount === 0 && groupsCount === 0) {
    return <WarningCell label={translation.no_devices_assigned} />;
  }

  return (
    <Box height="100%" display="flex" alignItems="center">
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Stack direction="row" spacing={0.5} alignItems="center">
          <LockOutlined sx={(theme) => ({ color: theme.palette.text.secondary })} />
          <Typography variant="caption">{devicesCount}</Typography>
        </Stack>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <FolderOpenOutlined sx={(theme) => ({ color: theme.palette.text.secondary })} />
          <Typography variant="caption">{groupsCount}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default DevicesAndGroupsCell;
